import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";

import FocusAreas from "/react4xp/components/shared/FocusAreas/FocusAreas";

import type { FocusAreasPartProps } from "./FocusAreas.d";

export const FocusAreasPart = (props: ComponentProps<PartData>) => {
  const { areas, title, pageType } = (props.data as FocusAreasPartProps) ?? {};

  return (
    <section className={`bg-forest${pageType ? `-${pageType}` : ""}`}>
      <div className="wide-container">
        <FocusAreas areas={areas} titleFocusAreas={title} />
      </div>
    </section>
  );
};

export default FocusAreasPart;
